import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const importExcelData = createAsyncThunk(
    "leads/importExcel",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`${BackendURL}/leads/import-excel`, payload);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || { message: "Failed to import excel." }
            );
        }
    }
);


const leadImportSlice = createSlice({
    name: "leadImport",
    initialState: {
        loading: false,
        success: false,
        error: null,

        insertedCount: 0,
        duplicateCount: 0,
        insertedLeads: [],
        duplicateLeads: [],
    },

    reducers: {
        resetImportState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.insertedCount = 0;
            state.duplicateCount = 0;
            state.insertedLeads = [];
            state.duplicateLeads = [];
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(importExcelData.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })

            .addCase(importExcelData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;

                // Extract response from backend
                const {
                    insertedCount,
                    duplicateCount,
                    insertedLeads,
                    duplicateLeads,
                } = action.payload;

                state.insertedCount = insertedCount;
                state.duplicateCount = duplicateCount;
                state.insertedLeads = insertedLeads;
                state.duplicateLeads = duplicateLeads;
            })

            .addCase(importExcelData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || "Import failed.";
            });
    },
});

export const { resetImportState } = leadImportSlice.actions;
export default leadImportSlice.reducer;
